<template>
	<link-radio
		:color="color"
		:size="size"
		:label="label"
		isCheckAllRadio

		:active-icon="p_activeIcon"
		:disabled="disabled"
		readonly
		:width="width"

		:value="p_activeIcon === 'link-checkbox-inner-checked' || p_activeIcon === 'link-checkbox-inner-minus'"
		@click.native="onClick"
	/>
</template>

<script>
	export default {
		name: "link-check-all",
		props: {
			color: {type: String,},                             //颜色：primary|success|warn|error|info
			size: {type: String,},                              //大小：large|default|small
			label: {type: String, default: () => LinkVue.$t('LinkAutoTable.selectAll')},              //文本
			status: {type: String, default: 'none'},            //当前全选状态
			disabled: {type: Boolean},
			width: {},
		},
		inject: {
			radioGroup: {default: null},
		},
		watch: {
			status(val) {
				switch (val) {
					case 'all':
						this.$emit('select-all')
						break;
					case 'some':
						this.$emit('select-some')
						break;
					case 'none':
						this.$emit('select-none')
						break;
				}
			},
		},
		data() {
			return {
				STATUS: {
					'all': 'link-checkbox-inner-checked',
					'some': 'link-checkbox-inner-minus',
					'none': 'link-checkbox-inner-unchecked',
				},
			}
		},
		computed: {
			p_activeIcon() {
				return this.STATUS[this.status]
			},
		},
		methods: {
			onClick(e) {
				if (!!this.radioGroup && (this.radioGroup.lv_disabled || this.radioGroup.lv_readonly)) return
				this.$emit('click', e)
			}
		}
	}
</script>

<style lang="scss">

</style>
